<template>
    <div class="input" :style="{'width': width}">
        <input
            :id="htmlId"
            :autocomplete="autocomplete"
            :class="[{ 'filled' : filled || type === 'password' }, { 'disabled' : readonly }]"
            :disabled="readonly"
            :name="htmlId"
            :type="type"
            :value="value"
            :maxlength="maxlength"
            @keyup="updateValue($event)"
            @blur="$emit('blur', value)">
        <label :for="htmlId">{{ label }}</label>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filled: false,
            nullValue: false
        };
    },
    props: {
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        htmlId: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: false
        },
        formatType: {
            type: String,
            required: false
        },
        autocomplete: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        itemIndex: {
            type: Number,
            required: false,
            default: null
        },
        width: {
            type: String,
            required: false,
            default: '100%'
        },
        maxlength: {
            type: Number,
            required: false,
            default: null
        }
    },
    methods: {
        updateValue(e) {
            var mutationName = 'set' + this.htmlId;
            if (this.formatType === 'currency') {
                if (event.target.validity.valid) {
                    this.$store.commit(mutationName, e.target.value);
                }
            }
            else if (this.formatType === 'date') {
                //todo dziki zabieg
                this.$store.commit(mutationName, e.target.value.substring(0, 10));
            }
            else {
                if (this.itemIndex != null) {
                    mutationName = mutationName.replace('_' + this.itemIndex, '');
                    var data = { index: this.itemIndex, value: e.target.value };
                    this.$store.commit(mutationName, data);
                } else {
                    this.$store.commit(mutationName, e.target.value);
                }
            }
            this.$emit('update', e.target.value)
        },
        isFilled() {
            if (this.value && this.value.length > 0) this.filled = true;
            else this.filled = false;
        },
    },
    mounted() {
        this.isFilled();
    },
    updated() {
        this.isFilled();
    }
};
</script>